<template>
    <div>
        <img
            :src="env.APPS + 'assets/img/ajax-loader.gif'"
            :class="`m-${margin}`"
        />
    </div>
</template>

<script>
export default {
    props: {
        margin: {
            type: Number,
            default: 3
        }
    }
};
</script>
